import { combineReducers } from 'redux';
import initiativesTable from './Initiatives/reducer';
import createInitiative from './Create/reducer';
import editInitiative from './Edit/reducer';
import initiativeFormReducer from './Shared/InitiativeForm/reducer';
import { GET_INITIATIVE_SUCCESS } from './Edit/actionTypes';
import { GET_FORM_OPTIONS_SUCCESS } from './Create/actionTypes';
import { GET_TEMPLATES_SUCCESS } from './actionTypes';

const initialState = {
  loading: false,
  jurisdictions: [],
  organizations: [],
  templates: {},
  error: '',
};

const mainReducer = (state = initialState, {
  type, jurisdictions,
  organizations,
  templates,
}) => {
  switch (type) {
    case GET_INITIATIVE_SUCCESS:
      return {
        ...state,
        jurisdictions,
        organizations,
        templates,
      };
    case GET_FORM_OPTIONS_SUCCESS:
      return {
        ...state,
        jurisdictions,
        organizations,
      };
    case GET_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates,
      };
    default:
      return state;
  }
};

const initiativeReducer = combineReducers({
  main: mainReducer,
  table: initiativesTable,
  create: createInitiative,
  edit: editInitiative,
  form: initiativeFormReducer,
});

export default initiativeReducer;
